import { Component, OnInit } from '@angular/core';
import { BaseComponent } from "@bt/core/base";
import { NotifierService } from 'angular-notifier';
import { faTimes, faExclamationCircle, faArrowRight } from '@fortawesome/free-solid-svg-icons';
import { ExchangeService } from '@bt/core/services/exchange.service';
import { AssetBalanceModel } from '@bt/core/models/AssetBalance.model';
import { ExchangeWithdraw } from '@bt/core';
import { IResponse } from "@bt/shared";

@Component({
  selector: 'app-exchange',
  templateUrl: './exchange.component.html',
  styleUrls: ['./exchange.component.scss']
})
export class ExchangeComponent extends BaseComponent {
  faArrowRight = faArrowRight;
  faTimes = faTimes;
  faExclamationCircle = faExclamationCircle;

  private balanceUpdateTimer: NodeJS.Timer = null;

  constructor(
    private exchangeService: ExchangeService,
    private notifierService: NotifierService
  ) {
    super();
    this.isResponded = false;
  }

  public withdraws: ExchangeWithdraw[];
  public balances: AssetBalanceModel[];
  public balanceCost: number = 0;
  public hasBalances: boolean = true;
  public hasWithdraws: boolean = false;
  public isResponded: boolean;
  public isWithdrawsAvailable: boolean = false;
  public reason: string;

  ngOnInit() {
    const me = this;

    me.setLoading(true);
    const checkFunction = function () {
      me.loadBalances();
      me.setWithdrawalAvailableState();
    }

    me.balanceUpdateTimer = setInterval(checkFunction, 60 * 1000);
    checkFunction();
  }

  /**
   * Загружает балансы бирж
   */
  public loadBalances(): void {
    const me = this;

    me.exchangeService.getBalanceCost()
      .then((response: IResponse<number>) => {
        me.balanceCost = Number.isNaN(response.data) ? 0 : response.data;
        me.setLoading(false);
      })
      .catch((error: any) => {
        me.notifierService.notify('error', error.message);
        me.setLoading(false);
      });

    me.exchangeService.getAllBalances()
      .then((resp: IResponse<AssetBalanceModel[]>) => {
        if (resp.data != null && resp.data.length) {
          me.balances = resp.data;
          me.hasBalances = true;
        } else {
          me.hasBalances = false;
        }
        me.isResponded = true;
        me.setLoading(false);
      })
      .catch((error: any) => {
        me.hasBalances = false;
        me.isResponded = true;
        me.notifierService.notify('error', error.message);
        me.balanceUpdateTimer && clearInterval(me.balanceUpdateTimer);
        me.setLoading(false);
      });

    me.exchangeService.getExchangeWithdraws()
      .then((resp: IResponse<ExchangeWithdraw[]>) => {
        if (resp.data != null && resp.data.length) {
          me.withdraws = resp.data;
          me.hasWithdraws = true;
        } else {
          me.hasWithdraws = false;
        }
        me.isResponded = true;
        me.setLoading(false);
      })
      .catch((error: any) => {
        me.isResponded = true;
        me.notifierService.notify('error', error.message);
        me.balanceUpdateTimer && clearInterval(me.balanceUpdateTimer);
        me.setLoading(false);
      });
  }

  /**
   * Устанавливает текущее состояние вывода средств из биржи
   */
  public setWithdrawalAvailableState(): void {
    const me = this;

    me.exchangeService.checkWithdrawalAvailable().then((resp) => {
      me.isWithdrawsAvailable = resp.data;
      me.reason = me.isWithdrawsAvailable ? '' : resp.errorMsgs[0];
    });
  }

  /**
   * Создаёт запрос на перевод средств из биржи
   */
  public createWithdraws() {
    const me = this;

    me.exchangeService.CreateWithdrawRequest()
      .then((resp: any) => {
        if (resp.data) {
          me.notifierService.notify('success', "Запрос на вывод средств успешно создан");
          me.isWithdrawsAvailable = false;
        } else {
          me.notifierService.notify('error', resp.errorMsgs[0])
        }
        me.setLoading(false);
      })
      .then(() => {
        me.setWithdrawalAvailableState();
      })
      .catch((error: any) => {
        me.notifierService.notify('error', error.error.errorMsgs[0]);
        me.setLoading(false);
      });
  }
}



// WEBPACK FOOTER //
// ./src/app/exchange/exchange.component.ts